import { lmsApis } from '@shared/apis';
import { genericMutation, genericMutationWithId, genericQuery } from './generics';

export const useLMSCourses = genericQuery<lmsApis.GetAllLMSCourses>(lmsApis.getAllLMSCourses);

export const useLoginAndRedirectToCourse = genericMutation<lmsApis.LoginAndRedirectToCourse>(
  lmsApis.loginAndRedirectToCourse
);

export const useSyncUserLmsEnrollments = genericMutationWithId<lmsApis.SyncUserLmsEnrollments>(
  lmsApis.syncUserLmsEnrollments
);
